import React from 'react';
import { Newsletter } from '@components/organisms/Newsletter/Newsletter';

export default function ContentElementNewsletter(element) {
  return <Newsletter newsletter={element?.newsletter} />;
}
